import { Injectable } from "@angular/core"
import { Router } from "@angular/router"
import { MatDialog } from "@angular/material/dialog"
import { fromEvent, merge, timer, Subscription } from "rxjs"
import { switchMap, takeUntil } from "rxjs/operators"
import { AutolockWarningComponent } from "app/shared/dialogs/autolock-warning-dialog/autolock-warning-dialog.component"
import { AuthenticationService } from "./authentication.service"

@Injectable({ providedIn: "root" })
export class AutoSignOutService {
  private inactivitySubscription: Subscription
  private dialogRef: any
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private authService: AuthenticationService,
  ) {}

  startAutoSignout(minutes: number): void {
    var warningTime = minutes * 60 * 1000 - 20000 // 20 seconds before lock
    // Merge user activity events
    const userActivity$ = merge(fromEvent(document, "mousemove"), fromEvent(document, "keypress"), fromEvent(document, "mousedown"), fromEvent(document, "click"), fromEvent(document, "touchstart"))

    // Reset timer on user activity
    this.inactivitySubscription = userActivity$
      .pipe(
        switchMap(() => {
          // Clear any existing dialogs
          if (this.dialogRef) {
            this.dialogRef.close()
          }
          // Start warning timer
          return timer(warningTime).pipe(
            switchMap(() => {
              // Show warning dialog
              this.dialogRef = this.dialog.open(AutolockWarningComponent, {
                data: { signout: true },
                position: { top: "80px" },
                hasBackdrop: false,
                panelClass: "warning",
              })

              // Start lock timer
              return timer(20000).pipe(
                takeUntil(this.dialogRef.afterClosed()), // Cancel lock if dialog is closed
              )
            }),
          )
        }),
      )
      .subscribe(() => this.logoutFlow())
  }

  stopAutoSignout(): void {
    if (this.inactivitySubscription) {
      this.inactivitySubscription.unsubscribe()
    }
    this.dialog.closeAll()
  }

  private logoutFlow(): void {
    localStorage.setItem("STORAGE_LAST_VISITED_PAGE", this.router.url)
    this.dialog.closeAll()
    this.authService.logout("Auto sign-out due to inactivity")
    this.router.navigate(["/login"])
  }
}
